import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveFinancingSourcesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveFinancingSourcesParam } from 'api/types/params';

import {
  parseLegalClient,
  parseLegalClientFinancingSourcesParam,
} from './helpers';

export const useLegalClientSaveFinancingSources = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveFinancingSourcesMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveFinancingSources
      ? parseLegalClient(data.legalClientSaveFinancingSources)
      : undefined,
    loading,
    error,
    saveFinancingSources: useCallback(
      async (id: string, params: LegalClientSaveFinancingSourcesParam) => {
        const res = await handle({
          variables: {
            id,
            input: parseLegalClientFinancingSourcesParam(params),
          },
        });
        return res.data?.legalClientSaveFinancingSources
          ? parseLegalClient(res.data.legalClientSaveFinancingSources)
          : undefined;
      },
      [handle]
    ),
  };
};
